/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'bill-info': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M160 200h704a40 40 0 000-80H160a40 40 0 000 80zm736 56H128a64 64 0 00-64 64v576a64 64 0 0064 64h768a64 64 0 0064-64V320a64 64 0 00-64-64zM672 640a32 32 0 010 64H544v96a32 32 0 01-64 0v-96H352a32 32 0 010-64h128v-64H352a32 32 0 010-64h82.75l-73.38-73.37a32 32 0 0145.26-45.26L512 498.75l105.37-105.38a32 32 0 0145.26 45.26L589.25 512H672a32 32 0 010 64H544v64z"/>'
  }
})
